import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Invoicing.module.css';
import { CheckSmall } from '../../icons';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const Header = () => (
  <header className={styles.hero}>
    <div className={`${styles.container} ${styles.heroGrid}`}>
      <div>
        <div className={`${styles.breadcrumb} ${styles.reveal} ${styles.d1}`}>
          <Link to="/">Fyntiq Business</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <Link to="/#features">Features</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <span className={styles.breadcrumbCur}>Invoicing</span>
        </div>
        <h1 className={`${styles.reveal} ${styles.d2}`}>
          Send invoices.<br /><span className={styles.hl}>Get paid.</span>
        </h1>
        <p className={`${styles.heroSub} ${styles.reveal} ${styles.d3}`}>
          Create branded invoices with a built-in Pay Now button, let customers pay any way they like, and watch payments reconcile themselves.
        </p>
        <div className={`${styles.heroCta} ${styles.reveal} ${styles.d4}`}>
          <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Get started free</Link>
          <a href="#how" className={styles.btnOutlineHero}>See how it works</a>
        </div>
        <div className={`${styles.heroNote} ${styles.reveal} ${styles.d5}`}>
          <span><CheckSmall />Unlimited invoices</span>
          <span><CheckSmall />Free to start</span>
          <span><CheckSmall />No code</span>
        </div>
      </div>

      <div className={`${styles.heroVisual} ${styles.reveal} ${styles.d3}`}>
        <div className={`${styles.floatChip} ${styles.fcCash}`}>
          <div className={`${styles.fcIc} ${styles.fcIcY}`}>
            <svg viewBox="0 0 24 24" width="18" fill="none" stroke="#161614" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16v16H4z" /><path d="M8 9h8M8 13h5" />
            </svg>
          </div>
          <div><div className={styles.fcLab}>Invoice sent</div><div className={styles.fcVal}>#1043</div></div>
        </div>
        <div className={`${styles.floatChip} ${styles.fcPayout}`}>
          <div className={`${styles.fcIc} ${styles.fcIcG}`}>
            <svg viewBox="0 0 24 24" width="18" fill="none" stroke="#2EB66E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3v13m0 0l-4-4m4 4l4-4M5 21h14" />
            </svg>
          </div>
          <div><div className={styles.fcLab}>Deposited</div><div className={styles.fcVal}>$1,240.00</div></div>
        </div>

        <div className={styles.payCard}>
          <div className={styles.invTop}>
            <div><div className={styles.invLab}>INVOICE</div><div className={styles.invNum}>#1043 · Northbeam Studio</div></div>
            <span className={styles.invStatus} style={{ background: 'var(--green-soft)', color: 'var(--green)' }}>Paid</span>
          </div>
          <div className={styles.invRow}><span>Brand strategy session</span><span className={styles.mono}>$1,000.00</span></div>
          <div className={styles.invRow}><span>Logo revisions (2)</span><span className={styles.mono}>$240.00</span></div>
          <div className={styles.invTotal}><span>Total</span><span className={styles.mono}>$1,240.00</span></div>
          <div className={styles.invPaynow} style={{ background: 'var(--green)' }}>Paid ✓</div>
        </div>
      </div>
    </div>
  </header>
);

export default Header;
